import { createStore } from "vuex";
import axios from "axios";

const BASE_URI =
  process.env.VUE_APP_BASE_URI !== undefined
    ? process.env.VUE_APP_BASE_URI
    : "https://api.onecoffeeapp.com.au";

function updateLocalStorage(cart) {
  localStorage.setItem("cart", JSON.stringify(cart));
}

let cartFetchPromise = null;

export default createStore({
  state: {
    cart: [],
    cartOrders: [],
    cartOrdersLoading: false,
    cartOrdersLastFetch: null,
  },
  getters: {
    productQuantity: (state) => (product) => {
      const item = state.cart.find((i) => i.id === product.id);

      if (item) return item.quantity;
      else return null;
    },
    cartOrdersCount: (state) => state.cartOrders.length,
    isCartFresh: (state) => {
      if (!state.cartOrdersLastFetch) return false;
      const fiveMinutes = 5 * 60 * 1000;
      return Date.now() - state.cartOrdersLastFetch < fiveMinutes;
    },
    isLoggedIn: () => {
      const token = localStorage.getItem("token");
      return token !== null && token !== "null" && token !== "";
    },
  },
  mutations: {
    addToCart(state, product) {
      let item = state.cart.find((i) => i.id === product.id);

      if (item) {
        item.quantity++;
      } else {
        state.cart.push({ ...product, quantity: 1 });
      }

      updateLocalStorage(state.cart);
    },
    setCartOrders(state, orders) {
      state.cartOrders = orders;
      state.cartOrdersLastFetch = Date.now();
    },
    setCartOrdersLoading(state, loading) {
      state.cartOrdersLoading = loading;
    },
    invalidateCart(state) {
      state.cartOrdersLastFetch = null;
    },
    clearStore(state) {
      state.cart = [];
      state.cartOrders = [];
      state.cartOrdersLoading = false;
      state.cartOrdersLastFetch = null;
      updateLocalStorage(state.cart);
    },
  },
  actions: {
    async fetchCartOrders({ commit, state, getters }, { force = false } = {}) {
      // Return cached data if fresh and not forcing refresh
      if (!force && getters.isCartFresh) {
        return state.cartOrders;
      }

      // If already loading, return the existing promise to prevent duplicate requests
      if (cartFetchPromise) {
        return cartFetchPromise;
      }

      commit("setCartOrdersLoading", true);

      cartFetchPromise = (async () => {
        try {
          const token = localStorage.getItem("token");
          const isValidToken =
            token && token !== "null" && token !== "undefined" && token !== "";

          if (!isValidToken) {
            commit("setCartOrders", []);
            return [];
          }

          const axiosConfig = {
            headers: {
              Authorization: token,
              "Content-Type": "application/json;charset=UTF-8",
            },
          };

          const url = `${BASE_URI}/cart/get-cart-orders/?status=pending&groupByCafeId=true`;

          const result = await axios.get(url, axiosConfig);
          const orders = result?.data?.data?.length ? result.data.data : [];

          commit("setCartOrders", orders);
          return orders;
        } catch (error) {
          console.error("[Vuex] Error fetching cart orders:", error);
          commit("setCartOrders", []);
          return [];
        } finally {
          commit("setCartOrdersLoading", false);
          cartFetchPromise = null;
        }
      })();

      return cartFetchPromise;
    },
  },
  modules: {},
});
